import * as React from "react";
import {GoogleMap} from "react-google-maps";
import MapUtils from "../../utils/MapUtils";
import withScriptjs from "react-google-maps/lib/withScriptjs";
import withGoogleMap from "react-google-maps/lib/withGoogleMap";

interface ComponentProps {
	center?: { lat: number, lng: number }
	zoom?: number;
	onInit?: (gm: GoogleMap) => void;
}

type Props = ComponentProps;

/**
 * Map instance.
 */
export default class Map extends React.PureComponent<Props, {}> {

	/**
	 * Google map component
	 */
	MapComponent = withScriptjs(withGoogleMap((props) =>
		<GoogleMap {...props} center={this.props.center} zoom={this.props.zoom} defaultZoom={9}
				   defaultCenter={{lat: 51.919516, lng: -0.2850921}} ref={(gm) => {this.props.onInit && this.props.onInit(gm)}}/>
	));

	render() {
		const url = `https://maps.googleapis.com/maps/api/js?key=${MapUtils.API_KEY}&v=3.exp&libraries=geometry,drawing,places`;
		return (
			<this.MapComponent containerElement={<div style={{height: "100%"}}/>}
							   googleMapURL={url}
							   loadingElement={<div style={{height: "100%"}}/>}
							   mapElement={<div style={{height: "100%"}}/>}>
				{this.props.children}
			</this.MapComponent>
		)
	}
};
